import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PurchasingVendorDeliveryRequestActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/VendorDeliveryRequest/VendorDeliveryRequestBrowser")
	}

	render() {
		return (
			<Activity 
				name="PurchasingVendorDeliveryRequest"
				RenderedComponent={this.RenderedComponent}
				context="PurchasingVendorDeliveryRequest"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PurchasingVendorDeliveryRequestActivity)
